// Locale für PayPal-SDK und Amazon-Pay-Button, wenn der Proxy keine mitliefert.
// reference: [m7_base_payment/src/Core/ProviderLocale 1]
import {getLocale} from '$m7-library/utils/i18n.js';

export function providerLocale() {
    return getLocale().replace('-', '_');
}
